<template>
  <card class="task-options__card">
    <template #header>
      <div class="card-text">
        <div class="card-icon" :class="icon.color">
          <el-icon v-if="!icon.iconClass" class="nc-icon">
            <component :is="icon.icon"/>
          </el-icon>
          <i v-else class="nc-icon" :class="icon.icon"/>
        </div>
        <h4 class="card-title">
          {{ title }}
        </h4>
        <p class="card-category">
          Для редактирования кликните по значению
        </p>
      </div>
    </template>
    <p v-if="isCostLimits" class="card-category">
      Задачи в рублях
    </p>
    <el-table v-if="!!list.length || !!RUBLimitsList" :data="isCostLimits ? RUBLimitsList : list">
      <el-table-column v-if="isCostLimits" align="left" prop="meta.ru.title"/>
      <el-table-column v-else align="left" prop="meta.ru.description"/>
      <el-table-column align="right" width="200px">
        <template #default="scope">
          <div
            v-if="editedValueId !== scope.row.id"
            @click="() => {editedValueId = scope.row.id}">
            {{ scope.row.value }}
          </div>
          <div v-else>
            <fg-input
              :ref="`input-${scope.row.id}`"
              v-model="scope.row.value"
              type="text"
              class="task-options__edit-in-place"
              transform-method="onlyDigits"
              @created="handleInputCreated"
              @blur="handleInputBlur"
              @pressEnter="handleInputBlur"/>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <template v-if="isCostLimits">
      <p class="card-category mt-3">
        Задачи в USD
      </p>
      <el-table v-if="!!USDLimitsList.length" :data="USDLimitsList">
        <el-table-column align="left" prop="meta.ru.title"/>
        <el-table-column align="right" width="200px">
          <template #default="scope">
            <div
              v-if="editedValueId !== scope.row.id"
              @click="() => {editedValueId = scope.row.id}">
              {{ scope.row.value }}
            </div>
            <div v-else>
              <fg-input
                :ref="`input-${scope.row.id}`"
                v-model="scope.row.value"
                type="text"
                class="task-options__edit-in-place"
                transform-method="onlyDigits"
                @created="handleInputCreated"
                @blur="handleInputBlur"
                @pressEnter="handleInputBlur"/>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template #footer>
      <div v-if="loading" class="task-options__dummy">
        <indicator/>
      </div>
      <div v-else class="task-options__toolbar">
        <p-button :disabled="btnDisabled" @click="updateData">
          Применить
        </p-button>
      </div>
    </template>
  </card>
</template>

<script>
import Indicator from '@/components/UIComponents/Custom/Indicator'
import { mapGetters } from 'vuex'

export default {
  name: 'TaskOptionsCard',
  components: {
    Indicator
  },
  props: {
    title: String,
    icon: {
      icon: String,
      color: String
    },
    actionForGetData: Function,
    actionForUpdateData: Function,
    initData: Array,
    limitsType: String
  },
  data() {
    return {
      list: [],
      loading: null,
      editedValueId: null,
      disable: false
    }
  },
  computed: {
    ...mapGetters(['activeRoleName']),
    changedDataIds() {
      const result = []
      for (const item of this.list) {
        if (!item.value) {
          item.value = 0
        }
        const initItem = this.initData.find(option => option.id === item.id)
        if (parseInt(item.value) !== parseInt(initItem.value)) {
          result.push(item.id)
        }
      }
      return result
    },
    btnDisabled() {
      return !this.changedDataIds.length
    },
    isCostLimits() {
      return ['create', 'update'].includes(this.limitsType)
    },
    USDLimitsList() {
      return this.list.filter(item => item.meta.currency_code === 'USD')
    },
    RUBLimitsList() {
      return this.list.filter(item => item.meta.currency_code === 'RUB')
    }
  },
  methods: {
    async getData() {
      this.loading = true
      try {
        await this.actionForGetData({ limitsType: this.limitsType })
      } finally {
        this.loading = false
      }
    },
    async updateData() {
      this.loading = true
      try {
        const changedData = this.list.filter(item => this.changedDataIds.includes(item.id))
        await this.actionForUpdateData({
          changedData,
          limitsType: this.limitsType
        })
      } finally {
        this.loading = false
      }
    },
    handleInputCreated() {
      const value = this.editedValueId
      if (!value) return
      this.$refs[`input-${value}`].onFocus()
    },
    handleInputBlur() {
      this.editedValueId = null
    }
  },
  async beforeMount() {
    await this.getData()
    this.list = _.cloneDeep(this.initData)
  }
}
</script>

<style scoped>

</style>
